import React from "react"
import { OuterMenuItemTypes } from "../CommandBar"
import { OuterMenuItem } from "./OutMenuItem"

type OuterMenuListingType = {
    outerMenuItems: OuterMenuItemTypes[];
}

export const OuterMenuListing: React.FC<OuterMenuListingType> = ({
    outerMenuItems
}) => {
    return (
        <>          
            {outerMenuItems.map((x, index) => (
                <OuterMenuItem 
                criteria={x.criteria}
                openSubMenu={x.openSubMenu}
                icon={x.icon}
                index={index}
                onClick={x.onClick}
                text={x.text}
                optionalIcon={x.optionalIcon}
                />
            ))}
        </>
    )
}